export default "<app-multimedia-manager-dialog></app-multimedia-manager-dialog>"